import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { PieceJointe } from './piece-jointe.model';
import { PieceJointePopupService } from './piece-jointe-popup.service';
import { PieceJointeService } from './piece-jointe.service';
import { Piece, PieceService } from '../formation';
import { User, UserService } from '../../shared';
import { CandidatureFormation, CandidatureFormationService } from '../candidature';
@Component({
    selector: 'jhi-piece-jointe-dialog',
    templateUrl: './piece-jointe-dialog.component.html'
})
export class PieceJointeDialogComponent implements OnInit {

    pieceJointe: PieceJointe;
    authorities: any[];
    isSaving: boolean;

    pieces: Piece[];

    users: User[];

    candidatureformations: CandidatureFormation[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private pieceJointeService: PieceJointeService,
        private pieceService: PieceService,
        private userService: UserService,
        private candidatureFormationService: CandidatureFormationService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['pieceJointe']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.pieceService.query().subscribe(
            (res: Response) => { this.pieces = res.json(); }, (res: Response) => this.onError(res.json()));
        this.userService.query().subscribe(
            (res: Response) => { this.users = res.json(); }, (res: Response) => this.onError(res.json()));
        this.candidatureFormationService.query().subscribe(
            (res: Response) => { this.candidatureformations = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear () {
        this.activeModal.dismiss('cancel');
    }

    save () {
        this.isSaving = true;
        if (this.pieceJointe.id !== undefined) {
            this.pieceJointeService.update(this.pieceJointe)
                .subscribe((res: PieceJointe) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        } else {
            this.pieceJointeService.create(this.pieceJointe)
                .subscribe((res: PieceJointe) => this.onSaveSuccess(res), (res: Response) => this.onSaveError(res.json()));
        }
    }

    private onSaveSuccess (result: PieceJointe) {
        this.eventManager.broadcast({ name: 'pieceJointeListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError (error) {
        this.isSaving = false;
        this.onError(error);
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }

    trackPieceById(index: number, item: Piece) {
        return item.id;
    }

    trackUserById(index: number, item: User) {
        return item.id;
    }

    trackCandidatureFormationById(index: number, item: CandidatureFormation) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-piece-jointe-popup',
    template: ''
})
export class PieceJointePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private pieceJointePopupService: PieceJointePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if ( params['id'] ) {
                this.modalRef = this.pieceJointePopupService
                    .open(PieceJointeDialogComponent, params['id']);
            } else {
                this.modalRef = this.pieceJointePopupService
                    .open(PieceJointeDialogComponent);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/piece-jointe/piece-jointe-dialog.component.ts